const products = [
  {
    id: 1,
    name: "6kg Gas Cylinder (with gas)",
    price: "K1,800.00",
    image: "/images/products/6kg-gas.jpg",
    category: "cylinders",
    description: "Portable 6kg LPG cylinder for home cooking",
  },
  {
    id: 2,
    name: "9kg Gas Cylinder",
    price: "K480.00",
    image: "/images/products/9kg-cylinder.png",
    category: "cylinders",
    description: "Medium 9kg cylinder, ideal for family use",
  },
  {
    id: 3,
    name: "19kg Gas Cylinder",
    price: "K1,020.00",
    image: "/images/products/19kg-gas.png",
    category: "cylinders",
    description: "19kg commercial cylinder",
  },
  {
    id: 4,
    name: "45kg Gas Cylinder",
    price: "K2,400.00",
    image: "/images/products/48kg-gas.png",
    category: "cylinders",
    description: "Large 48kg cylinder for heavy usage",
  },
  {
    id: 5,
    name: "Burner",
    price: "K150.00",
    image: "/images/products/burner.jpg",
    category: "appliances",
    description: "Single gas burner",
  },
  {
    id: 6,
    name: "2 Plate Gas Cooker",
    price: "K1,400.00",
    image: "/images/products/stove.png",
    category: "appliances",
    description: "Double burner gas cooker",
  },
  {
    id: 7,
    name: "Gas Hose",
    price: "K90.00",
    image: "/images/products/pipe.jpg",
    category: "accessories",
    description: "High‑quality LPG hose",
  },
  {
    id: 8,
    name: "Bullnose Regulator",
    price: "K400.00",
    image: "/images/products/bullnose-regulator.jpg",
    category: "accessories",
    description: "Bullnose LPG regulator",
  },
  {
    id: 9,
    name: "Seville Regulator",
    price: "K350.00",
    image: "/images/products/regulator.jpg",
    category: "accessories",
    description: "Standard LPG regulator",
  },
  {
    id: 10,
    name: "Ring (Stand)",
    price: "K250.00",
    image: "/images/products/ring-stand.jpg",
    category: "accessories",
    description: "Ring for burner",
  },
];

export default products;
